import './stores';
export function getPointsById(round, playerId) {
    return round.filter(({ id }) => id === playerId)[0].points;
}
export function getTotalScoreById(scores, playerId) {
    const totalScore = scores.reduce(function (acc, curr) {
        const playerScore = curr.find((score) => score.id === playerId);
        return (acc += playerScore.points);
    }, 0);
    return totalScore;
}
export function getAccumulativeScoreById(scores, playerId, roundNumber) {
    let scoresUpToRound = scores.slice(0, roundNumber + 1);
    const totalScore = scoresUpToRound.reduce(function (acc, curr) {
        const playerScore = curr.find((score) => score.id === playerId);
        return (acc += playerScore.points);
    }, 0);
    return totalScore;
}
